export const lightColors = {
  "graph-blue": "#6896F5",
  "graph-green": "#6AB89F",
  "graph-tofino": "#83B8BE",
  "graph-purple": "#A58DED",
  "graph-orange": "#DF9C31",
  "graph-red": "#FA758A",
  "graph-neutral": "#B6BABB",

  "surface-base": "#FFFFFF",
  "surface-sunken": "#F7F8F8",
  "surface-overlay": "#FFFFFF",
  "surface-modal": "#1220237D",

  "background-base": "#FFFFFF",
  "background-input": "#FFFFFF",
  "background-input-hover": "#F7F8F8",
  "background-input-disabled": "#F7F8F8",
  "background-ghost-hover": "#12202308",
  "background-inverse": "#243134",
  "background-inverse-ghost-hover": "#CEDBE214",
  "background-selected-medium": "#8B9293",
  "background-selected-medium-hover": "#788082",
  "background-selected-strong": "#354144",
  "background-selected-disabled": "#12202324",
  "background-selected-weak": "#F1F2F2",
  "background-selected-weak-hover": "#F7F8F8",
  "background-active": "#F1F2F2",
  "background-active-hover": "#DEDFE0",

  "background-brand-primary-strong": "#008669",
  "background-brand-primary-strong-hover": "#17715D",
  "background-brand-primary-weak": "#EBF8F2",
  "background-brand-primary-weak-hover": "#CEE9DE",

  "background-success-strong": "#008669",
  "background-success-strong-hover": "#17715D",
  "background-success-weak": "#EBF8F2",
  "background-success-weak-hover": "#CEE9DE",
  "background-info-strong": "#2F5CBC",
  "background-info-strong-hover": "#1E4CAB",
  "background-info-weak": "#EDF1FB",
  "background-info-weak-hover": "#D2DFF8",
  "background-warning-strong": "#AB5308",
  "background-warning-strong-hover": "#9E4708",
  "background-warning-weak": "#FDF5EA",
  "background-warning-weak-hover": "#FCE1B9",
  "background-danger-strong": "#CE3056",
  "background-danger-strong-hover": "#C32247",
  "background-danger-weak": "#FEF0F1",
  "background-danger-weak-hover": "#FCD6DC",
  "background-danger-input": "#FEF0F1",

  "background-accent-neutral-weak": "#F1F2F2",
  "background-accent-neutral-medium": "#DEDFE0",
  "background-accent-neutral-strong": "#354144",
  "background-accent-tofino-strong": "#33777E",
  "background-accent-tofino-weak": "#D5E8EA",
  "background-accent-green-strong": "#008669",
  "background-accent-green-weak": "#CEE9DE",
  "background-accent-blue-strong": "#2F5CBC",
  "background-accent-blue-weak": "#D2DFF8",
  "background-accent-purple-strong": "#755AC3",
  "background-accent-purple-weak": "#E1D7FC",
  "background-accent-red-strong": "#CE3056",
  "background-accent-red-weak": "#FCD6DC",
  "background-accent-orange-strong": "#AB5308",
  "background-accent-orange-weak": "#FCE1B9",

  "border-base": "#12202324",
  "border-strong": "#8B9293",
  "border-input": "#8B9293",
  "border-input-hover": "#788082",
  "border-input-active": "#354144",
  "border-input-disabled": "#DEDFE0",
  "border-button": "#B6BABB",
  "border-button-hover": "#8B9293",
  "border-inverse": "#FFFFFF",

  "border-danger-input": "#CE3056",
  "border-danger-input-hover": "#C32247",
  "border-success": "#92C9B5",
  "border-success-hover": "#6AB89F",
  "border-info": "#91B3F7",
  "border-info-hover": "#6896F5",
  "border-warning": "#F9B64A",
  "border-warning-hover": "#DF9C31",
  "border-danger": "#F8A3AF",
  "border-danger-hover": "#FA758A",

  "text-base": "#243134",
  "text-weak": "#4A5557",
  "text-placeholder": "#60696C",
  "text-disabled": "#1220234f",
  "text-inverse": "#FFFFFF",
  "text-on-brand": "#FFFFFF",

  "text-success": "#008669",
  "text-success-hover": "#17715D",
  "text-info": "#2F5CBC",
  "text-info-hover": "#1E4CAB",
  "text-warning": "#AB5308",
  "text-warning-hover": "#9E4708",
  "text-danger": "#CE3056",
  "text-danger-hover": "#C32247",

  "text-accent-tofino": "#275A61",
  "text-accent-tofino-strong": "#134247",
  "text-accent-tofino-weak": "#EDF6F6",
  "text-accent-blue": "#1E4CAB",
  "text-accent-blue-strong": "#072F80",
  "text-accent-blue-weak": "#EDF1FB",
  "text-accent-green": "#17715D",
  "text-accent-green-strong": "#0F4D3F",
  "text-accent-green-weak": "#EBF8F2",
  "text-accent-purple": "#5C42AA",
  "text-accent-purple-strong": "#382B62",
  "text-accent-purple-weak": "#F4F0FF",
  "text-accent-red": "#C32247",
  "text-accent-red-strong": "#8B0E2C",
  "text-accent-red-weak": "#FEF0F1",
  "text-accent-orange": "#9E4708",
  "text-accent-orange-strong": "#703200",
  "text-accent-orange-weak": "#FDF5EA",

  "icon-base": "#354144",
  "icon-weak": "#60696C",
  "icon-disabled": "#B6BABB",
  "icon-inverse": "#ffffff",

  "icon-success": "#008669",
  "icon-info": "#2F5CBC",
  "icon-warning": "#AB5308",
  "icon-danger": "#CE3056",

  "icon-accent-tofino": "#33777E",
  "icon-accent-tofino-strong": "#134247",
  "icon-accent-tofino-weak": "#EDF6F6",
  "icon-accent-blue": "#2F5CBC",
  "icon-accent-blue-strong": "#153B87",
  "icon-accent-blue-weak": "#EDF1FB",
  "icon-accent-green": "#008669",
  "icon-accent-green-strong": "#0F4D3F",
  "icon-accent-green-weak": "#EBF8F2",
  "icon-accent-purple": "#755AC3",
  "icon-accent-purple-strong": "#382B62",
  "icon-accent-purple-weak": "#F4F0FF",
  "icon-accent-red": "#CE3056",
  "icon-accent-red-strong": "#8B0E2C",
  "icon-accent-red-weak": "#FEF0F1",
  "icon-accent-orange": "#9E4708",
  "icon-accent-orange-strong": "#703200",
  "icon-accent-orange-weak": "#FDF5EA",

  "brand-certn-moss": "#134247",
  "brand-certn-aqua": "#1BB793",
  "brand-certn-lime": "#64D88A",
  "brand-certn-mycrc": "#F9B64A",
  "brand-certn-brilliantwhite": "#FFFFFF",
  "brand-certn-yellow": "#FFE750",
  "brand-certn-platinum": "#EDF0F1",
  "brand-certn-slate": "#568A8F",
  "brand-certn-midnight": "#1D1E21",
  "brand-certn-logo": "#243134",
  "background-accent-neutral-weakest": "#F7F8F8",
  "background-accent-green-weakest": "#EBF8F2",
  "background-accent-tofino-weakest": "#EDF6F6",
  "background-accent-blue-weakest": "#EDF1FB",
  "background-accent-purple-weakest": "#F4F0FF",
  "background-accent-red-weakest": "#FEF0F1",
  "background-accent-orange-weakest": "#FDF5EA",

  "tofino-100": "#EDF6F6",
  "tofino-200": "#D5E8EA",
  "tofino-300": "#AACFD3",
  "tofino-400": "#83B8BE",
  "tofino-500": "#5DA5AD",
  "tofino-600": "#3E8D96",
  "tofino-700": "#33777E",
  "tofino-800": "#275A61",
  "tofino-900": "#134247",
  "tofino-1000": "#142E31",
};

export type CascadiaColorTypes = typeof lightColors;
export type CascadiaColor = keyof CascadiaColorTypes;

export const darkColors: Record<CascadiaColor, string> = {
  "graph-blue": "#2F5CBC",
  "graph-green": "#008669",
  "graph-tofino": "#33777E",
  "graph-purple": "#33777E",
  "graph-orange": "#AB5308",
  "graph-red": "#CE3056",
  "graph-neutral": "#3B4446",

  "surface-base": "#131515",
  "surface-sunken": "#101111",
  "surface-overlay": "#242829",
  "surface-modal": "#37404299",

  "background-base": "#131515",
  "background-input": "#131515",
  "background-input-hover": "#1E2122",
  "background-input-disabled": "#1E2122",
  "background-ghost-hover": "#F0F9FB0D",
  "background-inverse": "#D8DEDF",
  "background-inverse-ghost-hover": "#1220230F",
  "background-selected-medium": "#5C676A",
  "background-selected-medium-hover": "#7C878A",
  "background-selected-strong": "#C6CDCF",
  "background-selected-disabled": "#93B4BB29",
  "background-selected-weak": "#242829",
  "background-selected-weak-hover": "#F0F9FB0D",
  "background-active": "#242829",
  "background-active-hover": "#282F30",

  "background-brand-primary-strong": "#6AB89F",
  "background-brand-primary-strong-hover": "#92C9B5",
  "background-brand-primary-weak": "#13332C",
  "background-brand-primary-weak-hover": "#0F4D3F",

  "background-success-strong": "#6AB89F",
  "background-success-strong-hover": "#92C9B5",
  "background-success-weak": "#13332C",
  "background-success-weak-hover": "#0F4D3F",
  "background-info-strong": "#6896F5",
  "background-info-strong-hover": "#91B3F7",
  "background-info-weak": "#0F295E",
  "background-info-weak-hover": "#153B87",
  "background-warning-strong": "#DF9C31",
  "background-warning-strong-hover": "#F9B64A",
  "background-warning-weak": "#4F2500",
  "background-warning-weak-hover": "#703200",
  "background-danger-strong": "#FA758A",
  "background-danger-strong-hover": "#F8A3AF",
  "background-danger-weak": "#5C0E21",
  "background-danger-weak-hover": "#8B0E2C",
  "background-danger-input": "#5C0E21",

  "background-accent-neutral-weak": "#242829",
  "background-accent-neutral-medium": "#282F30",
  "background-accent-neutral-strong": "#C6CDCF",
  "background-accent-tofino-strong": "#AACFD3",
  "background-accent-tofino-weak": "#134247",
  "background-accent-green-strong": "#92C9B5",
  "background-accent-green-weak": "#0F4D3F",
  "background-accent-blue-strong": "#91B3F7",
  "background-accent-blue-weak": "#153B87",
  "background-accent-purple-strong": "#BDAAF4",
  "background-accent-purple-weak": "#382B62",
  "background-accent-red-strong": "#F8A3AF",
  "background-accent-red-weak": "#8B0E2C",
  "background-accent-orange-strong": "#F9B64A",
  "background-accent-orange-weak": "#703200",

  "border-base": "#93B4BB29",
  "border-strong": "#5C676A",
  "border-input": "#5C676A",
  "border-input-hover": "#7C878A",
  "border-input-active": "#C6CDCF",
  "border-input-disabled": "#282F30",
  "border-button": "#3B4446",
  "border-button-hover": "#5C676A",
  "border-inverse": "#131515",

  "border-danger-input": "#FA758A",
  "border-danger-input-hover": "#F8A3AF",
  "border-success": "#17715D",
  "border-success-hover": "#008669",
  "border-info": "#1E4CAB",
  "border-info-hover": "#2F5CBC",
  "border-warning": "#9E4708",
  "border-warning-hover": "#AB5308",
  "border-danger": "#C32247",
  "border-danger-hover": "#CE3056",

  "text-base": "#D8DEDF",
  "text-weak": "#AEB7BB",
  "text-placeholder": "#96A1A5",
  "text-disabled": "#6575787D",
  "text-inverse": "#131515",
  "text-on-brand": "#131515",

  "text-success": "#6AB89F",
  "text-success-hover": "#92C9B5",
  "text-info": "#6896F5",
  "text-info-hover": "#91B3F7",
  "text-warning": "#DF9C31",
  "text-warning-hover": "#F9B64A",
  "text-danger": "#FA758A",
  "text-danger-hover": "#F8A3AF",

  "text-accent-tofino": "#83B8BE",
  "text-accent-tofino-strong": "#D5E8EA",
  "text-accent-tofino-weak": "#142E31",
  "text-accent-blue": "#6896F5",
  "text-accent-blue-strong": "#D2DFF8",
  "text-accent-blue-weak": "#0F295E",
  "text-accent-green": "#6AB89F",
  "text-accent-green-strong": "#CEE9DE",
  "text-accent-green-weak": "#13332C",
  "text-accent-purple": "#A58DED",
  "text-accent-purple-strong": "#E1D7FC",
  "text-accent-purple-weak": "#241B3E",
  "text-accent-red": "#FA758A",
  "text-accent-red-strong": "#FCD6DC",
  "text-accent-red-weak": "#5C0E21",
  "text-accent-orange": "#DF9C31",
  "text-accent-orange-strong": "#FCE1B9",
  "text-accent-orange-weak": "#562900",

  "icon-base": "#C6CDCF",
  "icon-weak": "#96A1A5",
  "icon-disabled": "#3B4446",
  "icon-inverse": "#131515",

  "icon-danger": "#FA758A",
  "icon-info": "#6896F5",
  "icon-success": "#6AB89F",
  "icon-warning": "#DF9C31",

  "icon-accent-tofino": "#83B8BE",
  "icon-accent-tofino-strong": "#D5E8EA",
  "icon-accent-tofino-weak": "#142E31",
  "icon-accent-blue": "#6896F5",
  "icon-accent-blue-strong": "#D2DFF8",
  "icon-accent-blue-weak": "#0F295E",
  "icon-accent-green": "#6AB89F",
  "icon-accent-green-strong": "#CEE9DE",
  "icon-accent-green-weak": "#13332C",
  "icon-accent-purple": "#A58DED",
  "icon-accent-purple-strong": "#E1D7FC",
  "icon-accent-purple-weak": "#241B3E",
  "icon-accent-red": "#FA758A",
  "icon-accent-red-strong": "#FCD6DC",
  "icon-accent-red-weak": "#5C0E21",
  "icon-accent-orange": "#DF9C31",
  "icon-accent-orange-strong": "#FCE1B9",
  "icon-accent-orange-weak": "#4F2500",

  "brand-certn-moss": "#EEEFF0",
  "brand-certn-aqua": "#1BB793",
  "brand-certn-lime": "#64D88A",
  "brand-certn-mycrc": "#F9B64A",
  "brand-certn-brilliantwhite": "#FFFFFF",
  "brand-certn-yellow": "#FFE750",
  "brand-certn-platinum": "#EDF0F1",
  "brand-certn-slate": "#568A8F",
  "brand-certn-midnight": "#1D1E21",
  "brand-certn-logo": "#F7F8F8",

  "background-accent-neutral-weakest": "#1E2122",
  "background-accent-tofino-weakest": "#142E31",
  "background-accent-green-weakest": "#13332C",
  "background-accent-blue-weakest": "#0F295E",
  "background-accent-purple-weakest": "#241B3E",
  "background-accent-red-weakest": "#5C0E21",
  "background-accent-orange-weakest": "#562900",

  "tofino-100": "#EDF6F6",
  "tofino-200": "#D5E8EA",
  "tofino-300": "#AACFD3",
  "tofino-400": "#83B8BE",
  "tofino-500": "#5DA5AD",
  "tofino-600": "#3E8D96",
  "tofino-700": "#33777E",
  "tofino-800": "#275A61",
  "tofino-900": "#134247",
  "tofino-1000": "#142E31",
};
